"use strict";

var _slicedToArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPricePerUomAndExtendedPriceOfItem = exports.RemoveNotificationContainer = exports.RemoveFromCartNotification = exports.addImageDefaultSrc = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = require("react");

var styled_1 = __importDefault(require("@emotion/styled"));

var frontend_typography_1 = require("@ryerson/frontend.typography");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var react_2 = require("@emotion/react");

var frontend_button_1 = require("@ryerson/frontend.button");

var frontend_layout_2 = require("@ryerson/frontend.layout");

var common_uom_1 = require("@ryerson/common.uom");

var NotificationContent_1 = require("./NotificationContent");

var frontend_navigation_1 = require("@ryerson/frontend.navigation");

var frontend_assets_1 = require("@ryerson/frontend.assets");

var frontend_common_1 = require("@ryerson/frontend.common");

var Notification_1 = require("../Notification");

var Application_1 = require("../Application");

var NotificationsPane = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tposition: fixed;\n\tbottom: 0;\n\tleft: 0;\n\tz-index: 9;\n\twidth: 400px;\n\tbox-shadow: 0px 100px 80px rgba(0, 0, 0, 0.07), 0px 0px 17.869px rgba(0, 0, 0, 0.0417275),\n\t\t0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725);\n\t", ";\n"])), function (props) {
  var breakpoints = props.breakpoints;
  return "\n            @media screen and (max-width: ".concat(breakpoints.lg, ") {\n                width: 100%\n            }\n        ");
});
var Notification = styled_1.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\twidth: 100%;\n\tmax-height: 50vh;\n\toverflow-y: auto;\n\tborder-radius: 2px;\n\t", ";\n"])), function (props) {
  var bgColor = props.bgColor,
      borderColor = props.borderColor,
      isNative = props.isNative;
  return (0, react_2.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\t\t\tborder: 1px solid ", ";\n\t\t\tbackground: ", ";\n\t\t\tmargin-top: ", ";\n\t\t"])), borderColor, bgColor, isNative ? "60px" : "0");
});
var NotificationExpandable = styled_1.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\twidth: 100%;\n\tmax-height: 50vh;\n\toverflow-y: auto;\n\t", ";\n"])), function (props) {
  var bgColor = props.bgColor,
      isNative = props.isNative;
  return (0, react_2.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\t\t\tbackground: ", ";\n\t\t\tmargin-bottom: ", ";\n\t\t"])), bgColor, isNative ? "calc(env(safe-area-inset-bottom) + 60px)" : "0");
});
var Caret = styled_1.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\twidth: 0;\n\theight: 0;\n\ttop: -", "px;\n\tborder: ", "px solid transparent;\n\tleft: calc(50% - ", "px / 2);\n\talign-self: ", ";\n\tborder-bottom-color: ", ";\n\tposition: absolute;\n\tmargin-bottom: -", "px;\n"])), function (props) {
  return props.size * 2;
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.alignSelf;
}, function (props) {
  return props.bgColor;
}, function (props) {
  return props.size * 2;
});
var CaretButton = styled_1.default.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\tposition: absolute;\n\ttop: -10px;\n\tleft: calc(50% + 2px);\n"])));
var NotificationHeader = styled_1.default.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n\tmax-width: 100%;\n\tpadding: 20px;\n\tp {\n\t\tmargin: 0;\n\t}\n\t", ";\n"])), function (props) {
  var bgColor = props.bgColor;
  return (0, react_2.css)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n\t\t\tbackground: ", ";\n\t\t"])), bgColor);
});
var NotificationContainer = (0, styled_1.default)(frontend_layout_1.Flex)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n\tpadding: 0 20px;\n"])));
var NotificationContainerMobile = (0, styled_1.default)(frontend_layout_1.Flex)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n\tpadding: 10px 20px 0;\n\tborder-top: 1px solid ", ";\n"])), function (props) {
  return props.borderColor;
});
var PriceContainer = (0, styled_1.default)(frontend_layout_1.Flex)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n\twidth: 100%;\n\tpadding: 0 0 20px;\n"])));
var NotificationImageContainer = (0, styled_1.default)(frontend_layout_1.FlexItem)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n\twidth: 25%;\n\tmargin: 0 20px 0 0;\n\t", ";\n"])), function (props) {
  var imageBorderColor = props.imageBorderColor;
  return (0, react_2.css)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n\t\t\timg {\n\t\t\t\tmargin: 15px auto 0;\n\t\t\t\tborder-radius: 2px;\n\t\t\t\tborder: 1px solid ", ";\n\t\t\t}\n\t\t"])), imageBorderColor);
});
var NotificationLink = styled_1.default.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n\twidth: 100%;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\t", ";\n"])), function (props) {
  var color = props.color;
  return (0, react_2.css)(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n\t\t\tcolor: ", ";\n\t\t"])), color);
});

var addImageDefaultSrc = function addImageDefaultSrc(event) {
  event.target.src = "/NoImageImage.svg";
};

exports.addImageDefaultSrc = addImageDefaultSrc;

var RemoveFromCartNotification = function RemoveFromCartNotification(_ref) {
  var products = _ref.products,
      messageId = _ref.messageId,
      undoChanges = _ref.undoChanges,
      cartPricingData = _ref.cartPricingData,
      storeDirectory = _ref.storeDirectory;

  var _ref2 = (0, Notification_1.useNotifications)(),
      removeNotification = _ref2.removeNotification;

  var _ref3 = (0, frontend_theme_1.useTheme)(),
      theme = _ref3.theme;

  var _ref4 = (0, react_1.useState)(false),
      _ref5 = _slicedToArray(_ref4, 2),
      isNotificationsExpanded = _ref5[0],
      setIsNotificationsExpanded = _ref5[1];

  var _ref6 = (0, Application_1.useApplication)(),
      isNative = _ref6.isNative,
      language = _ref6.localization.language;

  var content = NotificationContent_1.NotificationContent[language] || NotificationContent_1.NotificationContent.en;
  var _theme$colors$primary = theme.colors.primary,
      white = _theme$colors$primary.white,
      lighterGray = _theme$colors$primary.lighterGray,
      gray = _theme$colors$primary.gray;
  var _theme$colors$seconda = theme.colors.secondary,
      lightBlue = _theme$colors$seconda.lightBlue,
      darkBlue = _theme$colors$seconda.darkBlue;
  var staticAssetsUrl = "".concat(process.env.GATSBY_ENV_URL || "", "/static-assets/images/renderings/");

  var displayExtendedPrice = function displayExtendedPrice(rowData, cartPricingData) {
    var priceData = (0, exports.getPricePerUomAndExtendedPriceOfItem)(rowData, cartPricingData);
    var currentExtendedPrice = Number(priceData.extendedPrice);
    var extendedPrice = Number.isNaN(currentExtendedPrice) ? priceData.extendedPrice : (0, frontend_common_1.displayPrice)(currentExtendedPrice);
    return extendedPrice;
  };

  var caretSize = 15;
  return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
    children: [(0, jsx_runtime_1.jsx)(frontend_layout_2.Media, {
      lessThan: "lg",
      children: (0, jsx_runtime_1.jsxs)(NotificationExpandable, {
        bgColor: white,
        isNative: isNative,
        children: [(0, jsx_runtime_1.jsx)(Caret, {
          className: "caret",
          size: caretSize,
          alignSelf: "center",
          left: "auto",
          right: "auto",
          bgColor: white
        }), (0, jsx_runtime_1.jsx)(CaretButton, {
          size: caretSize,
          children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
            size: "xs",
            icon: isNotificationsExpanded ? "chevron-down" : "chevron-up",
            onClick: function onClick() {
              setIsNotificationsExpanded(!isNotificationsExpanded);
            }
          })
        }), (0, jsx_runtime_1.jsx)(NotificationHeader, {
          bgColor: white,
          children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
            justifyContent: "space-between",
            children: [(0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
              children: [(0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
                variant: "p",
                size: "lg",
                type: "secondary",
                children: [content.removeTitle, " \xA0", (0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
                  variant: "span",
                  size: "sm",
                  color: gray,
                  type: "primary",
                  children: [products.length, " ", "".concat(content.product).concat(products.length > 1 ? "s" : "")]
                })]
              }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
                alignItems: "center",
                css: {
                  cursor: "pointer"
                },
                onClick: function onClick() {
                  undoChanges();
                  removeNotification();
                },
                children: [(0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
                  icon: "revert",
                  size: "sm",
                  color: lightBlue,
                  css: {
                    margin: "5px",
                    cursor: "pointer"
                  }
                }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                  color: lightBlue,
                  type: "secondary",
                  size: "md",
                  css: {
                    marginRight: "5px"
                  },
                  children: content.undo
                })]
              })]
            }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
              children: (0, jsx_runtime_1.jsx)(frontend_button_1.Button, {
                label: "",
                type: "secondary",
                variant: "outline",
                shape: "circle",
                leftIcon: "close",
                size: "xs",
                background: lightBlue,
                onClick: function onClick() {
                  removeNotification();
                }
              })
            })]
          })
        }), isNotificationsExpanded && products.map(function (product, index) {
          return (0, jsx_runtime_1.jsxs)(NotificationContainerMobile, {
            borderColor: lighterGray,
            children: [(0, jsx_runtime_1.jsx)(NotificationImageContainer, {
              imageBorderColor: lighterGray,
              children: (0, jsx_runtime_1.jsx)("img", {
                onError: function onError(event) {
                  return (0, exports.addImageDefaultSrc)(event);
                },
                src: "".concat(staticAssetsUrl).concat((0, frontend_common_1.toPascalCase)(product === null || product === void 0 ? void 0 : product.category)).concat((0, frontend_common_1.toPascalCase)(product === null || product === void 0 ? void 0 : product.form)).concat((product === null || product === void 0 ? void 0 : product.shape) !== "N/A" ? (0, frontend_common_1.toPascalCase)(product === null || product === void 0 ? void 0 : product.shape) : "", ".png"),
                width: "100%"
              })
            }), (0, jsx_runtime_1.jsxs)(PriceContainer, {
              direction: "column",
              children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                children: (0, jsx_runtime_1.jsx)(NotificationLink, {
                  css: {
                    marginTop: "15px"
                  },
                  color: lightBlue,
                  children: (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
                    size: "md",
                    to: (0, frontend_common_1.navigateToProductDetails)(product === null || product === void 0 ? void 0 : product.id, product === null || product === void 0 ? void 0 : product.altPartNumber, storeDirectory),
                    children: (0, frontend_common_1.determineProductDisplay)(product === null || product === void 0 ? void 0 : product.altPartNumber, product === null || product === void 0 ? void 0 : product.fastPath)
                  })
                })
              }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                  size: "md",
                  variant: "p",
                  type: "primary",
                  children: (0, frontend_common_1.determineProductDisplay)(product === null || product === void 0 ? void 0 : product.altPartNumber, product === null || product === void 0 ? void 0 : product.fastPath)
                })
              }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
                justifyContent: "space-between",
                children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                  size: "xs",
                  variant: "span",
                  type: "primary",
                  children: "".concat(content.leadTime, " ").concat(product.leadTimeDisplay)
                }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                  size: "xs",
                  variant: "span",
                  type: "primary",
                  children: content.extendedPrice
                })]
              }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
                justifyContent: "space-between",
                children: [(0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
                  children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                    size: "xs",
                    variant: "span",
                    type: "primary",
                    children: content.qty
                  }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                    size: "xs",
                    variant: "span",
                    color: darkBlue,
                    children: "".concat(product.quantity, " ").concat(common_uom_1.DefaultUOMDisplay[product.quantityUOM])
                  })]
                }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                  size: "sm",
                  variant: "span",
                  weight: "bolder",
                  color: darkBlue,
                  children: displayExtendedPrice(product, cartPricingData)
                })]
              })]
            })]
          }, index);
        })]
      })
    }), (0, jsx_runtime_1.jsx)(frontend_layout_2.Media, {
      greaterThanOrEqual: "lg",
      children: (0, jsx_runtime_1.jsxs)(Notification, {
        bgColor: white,
        borderColor: lighterGray,
        children: [(0, jsx_runtime_1.jsx)(NotificationHeader, {
          bgColor: lighterGray,
          children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
            justifyContent: "space-between",
            children: [(0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
              children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                variant: "p",
                size: "lg",
                type: "primary",
                children: content.removeTitle
              }), (0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
                variant: "span",
                type: "secondary",
                children: ["(", products.length, " ", "".concat(content.product).concat(products.length > 1 ? "s" : ""), ")"]
              })]
            }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
              children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
                children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                  children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
                    alignItems: "center",
                    css: {
                      cursor: "pointer"
                    },
                    onClick: function onClick() {
                      undoChanges();
                      removeNotification();
                    },
                    children: [(0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
                      icon: "revert",
                      size: "sm",
                      color: lightBlue,
                      css: {
                        margin: "5px",
                        cursor: "pointer"
                      }
                    }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                      color: lightBlue,
                      type: "secondary",
                      size: "sm",
                      css: {
                        marginRight: "5px"
                      },
                      children: content.undo
                    })]
                  })
                }), (0, jsx_runtime_1.jsx)(frontend_button_1.Button, {
                  label: "",
                  type: "secondary",
                  variant: "outline",
                  shape: "circle",
                  leftIcon: "close",
                  size: "xs",
                  background: lightBlue,
                  onClick: function onClick() {
                    removeNotification();
                  }
                })]
              })
            })]
          })
        }), products.map(function (product, index) {
          return (0, jsx_runtime_1.jsxs)(NotificationContainer, {
            children: [(0, jsx_runtime_1.jsxs)(NotificationImageContainer, {
              imageBorderColor: lighterGray,
              children: [(0, jsx_runtime_1.jsx)("img", {
                onError: function onError(event) {
                  return (0, exports.addImageDefaultSrc)(event);
                },
                src: "".concat(staticAssetsUrl).concat((0, frontend_common_1.toPascalCase)(product === null || product === void 0 ? void 0 : product.category)).concat((0, frontend_common_1.toPascalCase)(product === null || product === void 0 ? void 0 : product.form)).concat((product === null || product === void 0 ? void 0 : product.shape) !== "N/A" ? (0, frontend_common_1.toPascalCase)(product === null || product === void 0 ? void 0 : product.shape) : "", ".png"),
                width: "100%"
              }), (0, jsx_runtime_1.jsx)(NotificationLink, {
                css: {
                  marginBottom: "15px"
                },
                color: lightBlue,
                children: (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
                  size: "sm",
                  to: (0, frontend_common_1.navigateToProductDetails)(product === null || product === void 0 ? void 0 : product.id, product === null || product === void 0 ? void 0 : product.altPartNumber, storeDirectory),
                  children: (0, frontend_common_1.determineProductDisplay)(product === null || product === void 0 ? void 0 : product.altPartNumber, product === null || product === void 0 ? void 0 : product.fastPath)
                })
              })]
            }), (0, jsx_runtime_1.jsxs)(PriceContainer, {
              direction: "column",
              children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                size: "sm",
                variant: "p",
                type: "primary",
                children: (0, frontend_common_1.determineProductDisplay)(product === null || product === void 0 ? void 0 : product.altPartNumber, product === null || product === void 0 ? void 0 : product.fastPath)
              }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
                justifyContent: "space-between",
                children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                  size: "xs",
                  variant: "span",
                  type: "primary",
                  children: "".concat(content.leadTime, " ").concat(product.leadTimeDisplay)
                }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                  size: "xs",
                  variant: "span",
                  type: "primary",
                  children: content.extendedPrice
                })]
              }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
                justifyContent: "space-between",
                children: [(0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
                  children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                    size: "xs",
                    variant: "span",
                    type: "primary",
                    children: content.qty
                  }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                    size: "xs",
                    variant: "span",
                    color: darkBlue,
                    children: "".concat(product.quantity, " ").concat(common_uom_1.DefaultUOMDisplay[product.quantityUOM])
                  })]
                }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                  size: "sm",
                  variant: "span",
                  weight: "bolder",
                  color: darkBlue,
                  children: displayExtendedPrice(product, cartPricingData)
                })]
              })]
            })]
          }, index);
        })]
      })
    })]
  });
};

exports.RemoveFromCartNotification = RemoveFromCartNotification;

var RemoveNotificationContainer = function RemoveNotificationContainer() {
  var _a;

  var _ref7 = (0, Notification_1.useNotifications)(),
      notifications = _ref7.notifications;

  var _ref8 = (0, frontend_theme_1.useTheme)(),
      theme = _ref8.theme;

  return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {
    children: notifications.filter(function (message) {
      return message.type === "remove-from-cart";
    }).length > 0 && (0, jsx_runtime_1.jsx)(NotificationsPane, {
      breakpoints: theme.breakpoints,
      children: (_a = notifications.filter(function (message) {
        return message.type === "remove-from-cart";
      }).pop()) === null || _a === void 0 ? void 0 : _a.message
    })
  });
};

exports.RemoveNotificationContainer = RemoveNotificationContainer;

var getPricePerUomAndExtendedPriceOfItem = function getPricePerUomAndExtendedPriceOfItem(rowData, pricingOfCartItems) {
  var _a;

  var itemNumber = Number(rowData.id);
  var pricingInfoForItem = (_a = pricingOfCartItems === null || pricingOfCartItems === void 0 ? void 0 : pricingOfCartItems.items) === null || _a === void 0 ? void 0 : _a.find(function (priceItem) {
    return priceItem.itemNumber === itemNumber;
  });

  if (pricingInfoForItem) {
    var extendedPrice = Number(pricingInfoForItem.extendedPrice);
    return {
      extendedPrice: Number(extendedPrice).toFixed(2),
      pricePerUom: pricingInfoForItem.pricePerUom,
      isZero: (pricingInfoForItem === null || pricingInfoForItem === void 0 ? void 0 : pricingInfoForItem.pricePerUom) === 0 ? true : false,
      totalWeight: pricingInfoForItem === null || pricingInfoForItem === void 0 ? void 0 : pricingInfoForItem.weight
    };
  }

  return {
    extendedPrice: frontend_common_1.emDash,
    pricePerUom: frontend_common_1.emDash,
    isZero: false,
    totalWeight: frontend_common_1.emDash
  };
};

exports.getPricePerUomAndExtendedPriceOfItem = getPricePerUomAndExtendedPriceOfItem;